export default {
  api: {
    planets: 'https://swapi.dev/api/planets/' // '/api/planets/' - request to own server
  }
}